import Gantt from 'frappe-gantt';
import { atom } from 'recoil';

import { ScheduleSize } from '../types';

import { Task } from '@/features/saveSite/types';
import { DataFile } from '@/features/siteTop/types';

export type GanttSelectionState = {
  date?: {
    dataFile: DataFile;
    //unixtime
    selectedDateTime: number;
  };
  crosses?: {
    task: Task;
    dataFile: DataFile;
    selectedDateTime: number;
  }[];
  updatedAt?: number;
};

//選択中の要素
export const ganttSelectionState = atom<GanttSelectionState | null>({
  key: 'ganttSelection',
  default: null,
});

//スケジュールサイズ
export const scheduleSizeState = atom<ScheduleSize>({
  key: 'scheduleSize',
  default: ScheduleSize.MIDDLE,
});

//FrappeGanttのInstance
export const frappeGanttInstanceState = atom<Gantt | null>({
  key: 'frappeGanttInstance',
  default: null,
  //WARN 直す
  dangerouslyAllowMutability: true,
});

//FrapeeGanttのViewMode
export const frappeGanttViewModeState = atom<Gantt.viewMode>({
  key: 'frappeGanttViewMode',
  default: 'Day',
});

//開閉中のConstructionZoneId
export const openConstructionZoneIdsState = atom<number[]>({
  key: 'openConstructionZoneIds',
  default: [],
});

//初回描画完了フラグ
export const isGanttInitialRenderState = atom<boolean>({
  key: 'isGanttInitialRender',
  default: false,
});
